module.exports = [{
      plugin: require('/opt/build/repo/cnr-gatsby/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":2048},
    },{
      plugin: require('/opt/build/repo/cnr-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
